type PlayIconProps = React.SVGProps<SVGSVGElement>;

export const PlayIcon = (props: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.43A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.95,16,16,0,0,1,16.2.43L232.4,114.49A15.74,15.74,0,0,1,240,128Z" />
    </svg>
  );
};
